<template>
  <div class="footer">
    <div class="footer-row">
      <div class="footer-column">
        <span style="font-size: 16px;">中国科技创新协会</span>
        <div class="footer-inner-section"/>
        <div class="psc-inner" v-for="(item, index) in bottomData" :key="index" @click="_handleToDetail(item.ID)">
          <span style="margin-bottom: 10px;">{{ item.post_title }}</span>
          <span>{{ item.post_date }}</span>
        </div>
      </div>
      <div style="width: 50px;"/>
      <div class="footer-column">
        <span style="font-size: 16px;">联系我们</span>
        <div class="footer-inner-section"/>
        <span class="psc-space">地址： 深水埗基隆街153号</span>
        <span class="psc-space">电话： 00852-23813359</span>
        <span class="psc-space">传真： 00852-23813359</span>
      </div>
    </div>
    <div class="footer-section">
    </div>
    <div class="footer-row">
      <div class="span-footer">
        <span>版权所有：中国科技创新协会</span>
        <span style="margin-left: 20px;">技术支持：盒子科技</span>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/util/http"
export default {
  name: "FooterComponent",
  data() {
    return {
      bottomData: []
    }
  },
  mounted() {
    this._getList()
  },
  methods: {
    _getList() {
      http.get('bottomInfo')
          .then((res) => {
            if (res.data.status === 0) {
              this.bottomData = res.data.data
            }
          })
    },
  _handleToDetail(e) {
    this.$router.push({
      path: '/DetailPage',
      query: {
        p: e
      }
    })
  }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  height: auto;
  opacity: 0.99;
  position: relative;
  color: #ddd;
  background: #333;
  text-shadow: 0 0 1px #000;
  padding: 20px 40px;
  margin-top: 100px;
  -webkit-box-shadow: 0 -5px 0 rgba(0, 0, 0, .1);;
  -moz-box-shadow: 0 -8px 0 rgba(0, 0, 0, .1);
  box-shadow: 0 -8px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 14px;
}
.footer-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}
.footer-section {
  background: #dd3333;
  width: 100%;
  margin-top: 20px;
  height: 5px;
}
.footer-inner-section {
  background: #666;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 6px;
  height: 4px;
}
.span-footer {
  font-size: 15px;
  color: #f2f2f2;
  height: 60px;
  text-align: center;
  line-height: 60px;
}
.footer-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
}
.psc-space {
  margin-top: 10px;
  margin-bottom: 10px;
}
.psc-inner {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px 0;
  border-bottom: solid 1px #444;
  cursor: pointer;
}
</style>